import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var ListChecks = createReactComponent("ListChecks", ["svg", defaultAttributes, [["line", {
  x1: "10",
  y1: "6",
  x2: "21",
  y2: "6",
  key: "g3fxpu"
}], ["line", {
  x1: "10",
  y1: "12",
  x2: "21",
  y2: "12",
  key: "dmx5v6"
}], ["line", {
  x1: "10",
  y1: "18",
  x2: "21",
  y2: "18",
  key: "c5zasy"
}], ["polyline", {
  points: "3 6 4 7 6 5",
  key: "1eculw"
}], ["polyline", {
  points: "3 12 4 13 6 11",
  key: "1s1ef5"
}], ["polyline", {
  points: "3 18 4 19 6 17",
  key: "3aj6dh"
}]]]);
export default ListChecks;